module.exports = __webpack_public_path__ + "img/ADC.519a3de6.svg";